import BaseTracker from './base-tracker';

export default class ImpressionTracker extends BaseTracker {
  start() {
    this.track();
  }
}
